import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Container from "../../../../modules/commons/Container";
import SimpleButton from "../../../../modules/commons/SimpleButton";
// import SimpleInformationModal from "../../../../modules/popup/SimpleInformationModal";
import ReceivingContent from "./common/receivingContent";
import ReceivingGift from "../receivingGift/receivingGift";

class ReceivingItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  render() {
    return (
      <>
        <Container>
          <Tabs>
            <TabList>
              <Tab>HADIAH</Tab>
              <Tab>BARANG LAIN</Tab>
            </TabList>
            <TabPanel id="button_navigate_hadiah">
              <ReceivingGift {...this.props} />
            </TabPanel>
            <TabPanel id="button_navigate_barang_lain">
              <ReceivingContent tab="baranglain" {...this.props} />
            </TabPanel>
          </Tabs>
        </Container>
      </>
    );
  }
}

export default ReceivingItem;
